import { ShareBaseAppInterceptor } from './xSharebaseAppInterceptor';
import { PinTokenInterceptor } from './pinTokenInterceptor';

export const interceptorsModule = angular
	.module('sharebase-app.interceptors', [
		'sharebase.services'
	])
	.factory('sbaPinTokenInterceptor', PinTokenInterceptor)
	.factory('xSharebaseAppInterceptor', ShareBaseAppInterceptor);


// WEBPACK FOOTER //
// ./src/sharebase-app/interceptors/index.ts